import * as Dialog from "@radix-ui/react-dialog";
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import { RichText } from "../../../components/RichText";
import { SVGIcon } from "../../../components/SVGIcon";

import styles from "./index.module.scss";

export const OrderNumberPopup = (
    props: Immutable<{
        copy: string;
    }>,
): React.JSX.Element => {
    return (
        <Dialog.Root>
            <p className={styles.root}>
                {richT(t`How do I find my <trigger>Order Number</trigger>?`, {
                    trigger: (children) => (
                        <Dialog.Trigger className={styles.trigger}>
                            {children}
                        </Dialog.Trigger>
                    ),
                })}
            </p>
            <Dialog.Portal>
                <Dialog.Overlay className={styles.overlay} />
                <Dialog.Content className={styles.content}>
                    <Dialog.Close className={styles.close}>
                        <SVGIcon
                            name="closeIcon"
                            alt={t`Close`}
                            aria-hidden="true"
                        />
                    </Dialog.Close>
                    <RichText html={props.copy} />
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
